import {
  createRootRoute,
  Outlet,
  retainSearchParams,
} from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import { USE_ADMIN_SESSION_PARAM } from "src/domains/http/interceptors/use-admin-session-interceptor"
import { SKIP_APP_SELECT_PARAM } from "src/domains/session/use-redirect-to-app-select"
import { SessionProvider } from "src/domains/session/use-session"
import z from "zod"

// Validated app-wide so `retainSearchParams` can carry it across every in-app
// navigation; without this, navigating between routes would drop the param and
// admin mode would be lost mid-flow. `.catch` keeps a malformed value from
// failing validation for every route.
const searchSchema = z.object({
  [USE_ADMIN_SESSION_PARAM]: z.boolean().optional().catch(undefined),
  [SKIP_APP_SELECT_PARAM]: z.boolean().optional().catch(undefined),
})

export const Route = createRootRoute({
  validateSearch: searchSchema,
  search: {
    middlewares: [retainSearchParams([USE_ADMIN_SESSION_PARAM])],
  },
  component: () => (
    <SessionProvider>
      <div>
        <Outlet />
        <TanStackRouterDevtools />
      </div>
    </SessionProvider>
  ),
})
